module.exports = __webpack_public_path__ + "img/23.8be33f40.png";